import styled from 'styled-components';

import {
  RowStyles
} from './../../../../../../stories/core-components/Layouts/Layouts';

export const TabsWrap = styled.div(
    props => `
        ${RowStyles}
        align-items: center;
        background: #eff3f8;
        border-radius: 2.0rem;
        justify-content: space-between;
        width: 100%;
        margin-top: 2rem;
    `,
  );

  export const Tabs = styled.a(
    props => `
      display: flex;
      justify-content: center;
      align-items: center
      border-radius: 2rem;
      padding: 0 2rem;
      background: #eff3f8;
      color: #647a97;
      font-weight: bold;
      font-family:${props.theme.font.fontFamily};
      &.active, &:active{
        background: #2276e3;
        color: white
      }
    `,
  );
  export const SpanTabs = styled.span`
    padding: 0.8rem 1rem;
    text-transform: uppercase;
    display: flex;
    text-align: center;
 `
